(() => {
  const t = (i18n, key, fallback) =>
    (i18n && i18n[key] != null && String(i18n[key]).trim() !== '' && !String(i18n[key]).startsWith('translation missing'))
      ? i18n[key]
      : fallback;

  const cartAddUrl = () => {
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return `${root}cart/add.js`;
  };

  const norm = (s) =>
    String(s || '')
      .toLocaleLowerCase('tr-TR')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/×/g, 'x')
      .replace(/,/g, '.')
      .replace(/\s+/g, ' ')
      .trim();

  const includesAny = (hay, needles) => {
    if (!needles || !needles.length) return false;
    const h = norm(hay);
    return needles.some((n) => h.includes(norm(n)));
  };

  const excludesAny = (hay, needles) => {
    if (!needles || !needles.length) return true;
    const h = norm(hay);
    return !needles.some((n) => h.includes(norm(n)));
  };

    const formatMoney = (cents, _moneyFormat) => {
    if (cents == null || cents === '') return '—';
    const n = Number(cents);
    if (Number.isNaN(n)) return '—';
    const whole = Math.round(n / 100);
    return `${whole.toLocaleString('tr-TR')} ₺`;
  };

  const moneyOf = (variant, moneyFormat) => {
    if (!variant) return '—';
    return formatMoney(variant.price, moneyFormat);
  };

  const cartSectionIds = () =>
    Array.from(document.querySelectorAll('cart-items-component'))
      .map((el) => (el instanceof HTMLElement ? el.dataset.sectionId : null))
      .filter(Boolean);

  const notifyHorizonCart = async (addResponse, lines) => {
    let cartJson = null;
    try {
      cartJson = await fetch(((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + 'cart.js', {
        headers: { Accept: 'application/json' },
        credentials: 'same-origin',
      }).then((r) => r.json());
    } catch (_) {}

    try {
      const { CartLinesUpdateEvent } = await import('@shopify/events');
      const deferred = CartLinesUpdateEvent.createPromise();
      document.dispatchEvent(
        new CartLinesUpdateEvent({
          action: 'add',
          context: 'product',
          lines: lines || [],
          promise: deferred.promise,
        })
      );
      deferred.resolve({
        cart: cartJson ? CartLinesUpdateEvent.createCartFromAjaxResponse(cartJson) : undefined,
        detail: {
          items: cartJson?.items || [],
          source: 'hexbox-craft',
          itemCount: cartJson?.item_count,
          sections: addResponse?.sections || {},
          didError: false,
        },
      });
    } catch (err) {
      document.dispatchEvent(new CustomEvent('cart:refresh', { detail: cartJson || addResponse, bubbles: true }));
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: cartJson || addResponse, bubbles: true }));
    }
  };

  class HexboxCraft extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      const cfgEl = document.getElementById(this.dataset.configId || '');
      if (!cfgEl) return;
      try {
        this.config = JSON.parse(cfgEl.textContent);
      } catch (e) {
        console.error('[HexboxCraft] bad config', e);
        return;
      }

      this.i18n = this.config.i18n || {};
      this.variants = this.config.variants || [];
      this.adapters = (this.config.adapters || []).filter((a) => a && a.id && a.available !== false);
      this.option = this.config.option || {};
      this.moneyFormat = this.config.moneyFormat || '{{amount}} ₺';
      this.wantPrint = false;
      this.wantAdapter = false;
      this.adapterKey = this.option.defaultAdapterKey || this.adapters.find((a) => a.recommended)?.key || this.adapters[0]?.key || null;
      this.file = null;
      this._fileUrl = null;

      this._cacheDom();
      this._initPrintSource();
      this._bind();
      this._renderAdapterList();
      this._placePrintAfterCtas();
      this._markHosts();
      this._interceptCart();
      this._sync();
    }

    disconnectedCallback() {
      if (this._fileUrl) URL.revokeObjectURL(this._fileUrl);
    }

    _cacheDom() {
      this.adapterBtn = this.querySelector('[data-hx-adapter-btn]');
      this.adapterMeta = this.querySelector('[data-hx-adapter-meta]');
      this.adapterPriceEl = this.querySelector('[data-hx-adapter-price]');
      this.adapterPicks = this.querySelector('[data-hx-adapter-picks]');
      this.adapterList = this.querySelector('[data-hx-adapter-list]');
      this.printBtn = this.querySelector('[data-hx-print-btn]');
      this.printMeta = this.querySelector('[data-hx-print-meta]');
      this.printPriceEl = this.querySelector('[data-hx-print-price]');
      this.uploadEl = this.querySelector('[data-hx-upload]');
      this.printGuideEl = this.querySelector('[data-hx-print-guide]');
      this.fileInput = this.querySelector('[data-hx-file]');
      this.fileName = this.querySelector('[data-hx-file-name]');
      this.printWarning = this.querySelector('[data-hx-print-warning]');
      this.printStepEl = this.querySelector('[data-hx-print-step]');
      this.descEl = this.querySelector('[data-hx-desc]');
      this.basePriceEl = this.querySelector('[data-hx-base-price]');
      this.adapterRow = this.querySelector('[data-hx-adapter-row]');
      this.adapterLine = this.querySelector('[data-hx-adapter-line]');
      this.adapterStateEl = this.querySelector('[data-hx-adapter-state]');
      this.printRow = this.querySelector('[data-hx-print-row]');
      this.printLine = this.querySelector('[data-hx-print-line]');
      this.printStateEl = this.querySelector('[data-hx-print-state]');
      this.totalEl = this.querySelector('[data-hx-total]');
      this.statusEl = this.querySelector('[data-hx-status]');
    }

    _bind() {
      this.adapterBtn?.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        if (!this.adapters.length) return;
        if (this.wantAdapter) {
          this.wantAdapter = false;
        } else {
          this.wantAdapter = true;
          if (!this.adapterKey) {
            this.adapterKey = this.adapters.find((a) => a.recommended)?.key || this.adapters[0].key;
          }
        }
        this._sync();
      });
      this.printBtn?.addEventListener('click', () => {
        const next = !this.wantPrint;
        this.wantPrint = next;
        if (!next) {
          this._setFile(null);
          this.printSrc?.reset();
          this._sync();
          return;
        }
        this._sync();
        this._openPrintUpload();
      });
      this._bindFileUploads();
      this.adapterList?.addEventListener('click', (event) => {
        const btn = event.target.closest('[data-hx-adapter-key]');
        if (!btn) return;
        event.preventDefault();
        event.stopPropagation();
        const key = btn.getAttribute('data-hx-adapter-key');
        if (this.wantAdapter && this.adapterKey === key) {
          this.wantAdapter = false;
        } else {
          this.adapterKey = key;
          this.wantAdapter = true;
        }
        this._sync();
      });
    }

    _initPrintSource() {
      const pdp = window.HarfmixCraftPdp;
      this.printSrc =
        pdp && pdp.createPrintSource
          ? pdp.createPrintSource(this, 'hx', {
              onService: () => this._setFile(null),
              onChange: () => this._sync(),
            })
          : { source: 'upload', isService: false, noteValue: () => '', reset() {}, sync() {} };
    }

    /** Print add-on lives BELOW the buy buttons (same as standbox-craft.js). */
    _placePrintAfterCtas() {
      const step = this.printStepEl || this.printBtn?.closest('.craft-print-step');
      if (!step) return;
      const tryPlace = () => {
        const pdp = window.HarfmixCraftPdp;
        if (pdp && pdp.placePrintAfterCtas) {
          pdp.placePrintAfterCtas(this, step);
          return true;
        }
        return false;
      };
      if (tryPlace()) return;
      [50, 200, 600, 1500].forEach((ms) => setTimeout(tryPlace, ms));
    }

    _renderAdapterList() {
      if (!this.adapterList) return;
      this.adapterList.innerHTML = '';
      if (!this.adapters.length) {
        if (this.adapterBtn) this.adapterBtn.hidden = true;
        if (this.adapterRow) this.adapterRow.hidden = true;
        return;
      }
      const sorted = [...this.adapters].sort((a, b) => Number(!!b.recommended) - Number(!!a.recommended));
      sorted.forEach((adapter) => {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'hexbox-craft__adapter-opt';
        btn.setAttribute('data-hx-adapter-key', adapter.key);
        btn.setAttribute('aria-pressed', 'false');
        const badge = adapter.recommended
          ? ` <em>${t(this.i18n, 'adapterRecommended', 'Önerilen')}</em>`
          : '';
        btn.innerHTML = `
          <span class="hexbox-craft__adapter-opt-main">
            <span class="hexbox-craft__adapter-opt-title">${adapter.label}${badge}</span>
            <span class="hexbox-craft__adapter-opt-meta">${adapter.capacity || ''}</span>
          </span>
          <span class="hexbox-craft__adapter-opt-price">${moneyOf(adapter, this.moneyFormat)}</span>
        `;
        this.adapterList.appendChild(btn);
      });
    }


    _bindFileUploads() {
      const bindInput = (input, onFile) => {
        if (!input) return;
        input.addEventListener('change', () => onFile(input.files?.[0] || null));
        const drop = input.closest('label, .hexbox-craft__drop');
        if (!drop) return;
        ['dragenter', 'dragover'].forEach((ev) => {
          drop.addEventListener(ev, (e) => {
            e.preventDefault();
            e.stopPropagation();
            drop.classList.add('is-dragover');
          });
        });
        ['dragleave', 'drop'].forEach((ev) => {
          drop.addEventListener(ev, (e) => {
            e.preventDefault();
            e.stopPropagation();
            drop.classList.remove('is-dragover');
          });
        });
        drop.addEventListener('drop', (e) => {
          const file = e.dataTransfer?.files?.[0];
          if (!file) return;
          try {
            const dt = new DataTransfer();
            dt.items.add(file);
            input.files = dt.files;
          } catch (_) {}
          onFile(file);
        });
      };

      bindInput(this.fileInput, (file) => this._setFile(file));
    }

    _openPrintUpload({ scroll = true } = {}) {
      this.wantPrint = true;
      if (this.uploadEl) this.uploadEl.hidden = false;
      if (this.printBtn) this.printBtn.setAttribute('aria-pressed', 'true');
      if (scroll) {
        const target = this.uploadEl || this.printStepEl || this.printBtn?.closest('.craft-print-step') || this.printBtn;
        if (target) {
          requestAnimationFrame(() => {
            target.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'nearest' });
          });
        }
      }
      if (this.printSrc?.isService) {
        this.printSrc.noteEl?.focus?.({ preventScroll: true });
      } else {
        this.fileInput?.focus?.({ preventScroll: true });
      }
    }

    _markHosts() {
      document.querySelectorAll('product-info, .product, .product-information').forEach((el) => {
        el.classList.add('product--hexboxcraft');
        const boot = () => { if (window.HarfmixCraftPdp) { window.HarfmixCraftPdp.init({ quoteOnly: false }); return true; } return false; };
        if (!boot()) [50, 200, 600, 1500].forEach((ms) => setTimeout(boot, ms));
      });
    }

    _interceptCart() {
      const isOurAtcButton = (el) => {
        if (!(el instanceof Element)) return false;
        const btn = el.closest('button[type="submit"], button[name="add"], [name="add"]');
        if (!btn || btn.closest('hexbox-craft')) return false;
        return (
          document.body.contains(this) &&
          !!btn.closest('sticky-add-to-cart, .sticky-add-to-cart, product-form, .product-form, form[action*="/cart/add"]')
        );
      };
      const guard = (event) => {
        if (event.type === 'submit') {
          const form = event.target instanceof HTMLFormElement ? event.target : event.target.closest?.('form');
          if (!(form instanceof HTMLFormElement) || !/\/cart\/add/.test(form.action || '')) return;
          if (form.closest('hexbox-craft') || !document.body.contains(this)) return;
          event.preventDefault();
          event.stopPropagation();
          this._addToCart();
          return;
        }
        if (!isOurAtcButton(event.target)) return;
        event.preventDefault();
        event.stopPropagation();
        this._addToCart();
      };
      document.addEventListener('click', guard, true);
      document.addEventListener('submit', guard, true);
    }

    _findVariant(contains, excludes) {
      return (
        this.variants.find(
          (v) => includesAny(v.title, contains) && excludesAny(v.title, excludes || [])
        ) || null
      );
    }

    _selectedAdapter() {
      if (!this.wantAdapter) return null;
      return this.adapters.find((a) => a.key === this.adapterKey) || this.adapters[0] || null;
    }

    _resolved() {
      const opt = this.option;
      const base = this._findVariant(opt.baseContains, opt.baseExcludes);
      const print = this._findVariant(opt.printContains, []);
      const adapter = this._selectedAdapter();
      return { opt, base, print, adapter };
    }

    _setFile(file) {
      this.file = file || null;
      if (this._fileUrl) URL.revokeObjectURL(this._fileUrl);
      this._fileUrl = file && file.type?.startsWith('image/') ? URL.createObjectURL(file) : null;
      if (this.fileInput && !file) this.fileInput.value = '';
      this._sync();
    }

    _setStatus(msg, tone) {
      if (!this.statusEl) return;
      if (!msg) {
        this.statusEl.hidden = true;
        this.statusEl.textContent = '';
        return;
      }
      this.statusEl.hidden = false;
      this.statusEl.textContent = msg;
      this.statusEl.dataset.tone = tone || 'success';
    }

    _sync() {
      const i18n = this.i18n;
      const { opt, base, print, adapter } = this._resolved();

      if (this.descEl) this.descEl.innerHTML = opt?.description || '';

      if (this.adapterBtn) {
        this.adapterBtn.hidden = !this.adapters.length;
        this.adapterBtn.setAttribute('aria-pressed', this.wantAdapter ? 'true' : 'false');
      }
      if (this.adapterPicks) this.adapterPicks.hidden = !this.wantAdapter || !this.adapters.length;
      if (this.adapterMeta) {
        if (!this.adapters.length) {
          this.adapterMeta.textContent = t(i18n, 'adapterOff', 'Adaptör dahil değil');
        } else if (this.wantAdapter && adapter) {
          this.adapterMeta.textContent = `${adapter.label}${adapter.capacity ? ` · ${adapter.capacity}` : ''}`;
        } else {
          this.adapterMeta.textContent = t(i18n, 'adapterOff', 'Opsiyonel — kutuya dahil değil');
        }
      }
      if (this.adapterPriceEl) {
        this.adapterPriceEl.textContent =
          this.wantAdapter && adapter ? `+ ${moneyOf(adapter, this.moneyFormat)}` : '';
      }
      this.adapterList?.querySelectorAll('[data-hx-adapter-key]').forEach((btn) => {
        const active = this.wantAdapter && btn.getAttribute('data-hx-adapter-key') === this.adapterKey;
        btn.classList.toggle('is-active', active);
        btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      });

      if (this.printBtn) this.printBtn.setAttribute('aria-pressed', this.wantPrint ? 'true' : 'false');
      if (this.printMeta) {
        this.printMeta.textContent = this.wantPrint
          ? this.printSrc?.isService
            ? t(i18n, 'printSourceServiceValue', 'HarfMix tasarım / baskı hizmeti')
            : t(i18n, 'printOn', 'Eklendi — toplama dahil')
          : `${t(i18n, 'printSizeLabel', 'Baskı alanı')}: ${opt?.printArea || ''}`;
      }
      if (this.printPriceEl) {
        this.printPriceEl.textContent =
          this.wantPrint && print ? `+ ${moneyOf(print, this.moneyFormat)}` : '—';
      }
      if (this.uploadEl) this.uploadEl.hidden = !this.wantPrint;
      this.printSrc?.sync(this.wantPrint);
      if (this.printGuideEl) {
        const guideUrl = opt?.printGuideUrl || '';
        if (guideUrl) {
          this.printGuideEl.href = guideUrl;
          this.printGuideEl.hidden = false;
        } else {
          this.printGuideEl.removeAttribute('href');
          this.printGuideEl.hidden = true;
        }
      }

      if (this.printWarning) this.printWarning.hidden = true;

      if (this.fileName) {
        this.fileName.hidden = !this.file;
        this.fileName.textContent = this.file?.name || '';
      }

      const baseCents = Number(base?.price) || 0;
      const printCents = this.wantPrint ? Number(print?.price) || 0 : 0;
      const adapterCents = this.wantAdapter ? Number(adapter?.price) || 0 : 0;
      if (this.basePriceEl) this.basePriceEl.textContent = moneyOf(base, this.moneyFormat);

      if (this.adapterRow) {
        this.adapterRow.hidden = !this.adapters.length;
        this.adapterRow.classList.toggle('is-added', this.wantAdapter);
        if (this.adapterStateEl) {
          this.adapterStateEl.textContent = this.wantAdapter
            ? t(i18n, 'addonAdded', 'Eklendi')
            : t(i18n, 'addonNotAdded', 'Eklenmedi');
        }
        if (this.adapterLine) {
          this.adapterLine.textContent = this.wantAdapter
            ? `+ ${moneyOf(adapter, this.moneyFormat)}`
            : this.adapters[0]
              ? moneyOf(this.adapters.find((a) => a.recommended) || this.adapters[0], this.moneyFormat)
              : '—';
        }
      }

      if (this.printRow) {
        this.printRow.classList.toggle('is-added', this.wantPrint);
        if (this.printStateEl) {
          this.printStateEl.textContent = this.wantPrint
            ? t(i18n, 'addonAdded', 'Eklendi')
            : t(i18n, 'addonNotAdded', 'Eklenmedi');
        }
        if (this.printLine) {
          this.printLine.textContent =
            this.wantPrint && print ? `+ ${moneyOf(print, this.moneyFormat)}` : '—';
        }
      }
      if (this.totalEl) this.totalEl.textContent = formatMoney(baseCents + printCents + adapterCents, this.moneyFormat);

      if (base?.id) {
        const input = document.querySelector(`form[action*="/cart/add"] [name="id"]`);
        if (input) {
          input.value = String(base.id);
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    }

    async _addToCart() {
      const i18n = this.i18n;
      const { opt, base, print, adapter } = this._resolved();
      if (!base?.id || !base.available) {
        this._setStatus(t(i18n, 'variantMissing', 'Varyant bulunamadı.'), 'error');
        return;
      }
      const isService = Boolean(this.printSrc?.isService);
      if (this.wantPrint && !isService && !this.file) {
        if (this.printWarning) this.printWarning.hidden = false;
        this._openPrintUpload();
        this._setStatus(t(i18n, 'printRequired', 'Baskı dosyasını yükleyin veya HarfMix hizmetini seçin.'), 'error');
        return;
      }
      if (this.wantPrint && !print?.id) {
        this._setStatus(t(i18n, 'variantMissing', 'Baskı varyantı bulunamadı.'), 'error');
        return;
      }
      if (this.wantAdapter && !adapter?.id) {
        this._setStatus(t(i18n, 'variantMissing', 'Adaptör bulunamadı.'), 'error');
        return;
      }

      const fd = new FormData();
      let index = 0;
      const appendItem = (variantId, props, files) => {
        fd.append(`items[${index}][id]`, String(variantId));
        fd.append(`items[${index}][quantity]`, '1');
        Object.entries(props).forEach(([k, v]) => {
          if (v == null || v === '') return;
          fd.append(`items[${index}][properties][${k}]`, String(v));
        });
        (files || []).forEach(({ key, file }) => {
          if (!file) return;
          fd.append(`items[${index}][properties][${key}]`, file, file.name);
        });
        index += 1;
      };

      appendItem(base.id, {
        [t(i18n, 'propType', 'Ürün Tipi')]: 'Altıgen Lightbox',
        [t(i18n, 'propSize', 'Ölçü')]: opt?.label || '',
        [t(i18n, 'propAdapter', 'Adaptör')]: this.wantAdapter && adapter
          ? `${adapter.label}${adapter.capacity ? ` (${adapter.capacity})` : ''}`
          : t(i18n, 'no', 'Hayır'),
        [t(i18n, 'propPrint', 'Görsel Baskı')]: this.wantPrint ? t(i18n, 'yes', 'Evet') : t(i18n, 'no', 'Hayır'),
      });

      if (this.wantAdapter && adapter?.id) {
        appendItem(adapter.id, {
          [t(i18n, 'propType', 'Ürün Tipi')]: 'Güç Adaptörü',
          [t(i18n, 'propAdapter', 'Adaptör')]: adapter.title || adapter.label,
          _hx_addon: 'adapter',
          _hx_for: 'Altıgen Lightbox',
        });
      }

      if (this.wantPrint && print?.id) {
        const note = this.printSrc?.noteValue() || '';
        const printProps = {
          [t(i18n, 'propType', 'Ürün Tipi')]: 'Özel Dijital Baskı (1 adet)',
          [t(i18n, 'propSize', 'Ölçü')]: opt?.printArea || '',
          [t(i18n, 'propPrint', 'Görsel Baskı')]: t(i18n, 'yes', 'Evet'),
          [t(i18n, 'propPrintSource', 'Baskı tercihi')]: isService
            ? t(i18n, 'printSourceServiceValue', 'HarfMix tasarım / baskı hizmeti')
            : t(i18n, 'printSourceUploadValue', 'Dosya yükleme'),
          _hx_addon: 'print',
        };
        if (note) {
          printProps[t(i18n, 'propPrintNote', 'Baskı notu')] = note;
        }
        appendItem(
          print.id,
          printProps,
          isService ? [] : [{ key: t(i18n, 'propPrintFile', 'Baskı Dosyası'), file: this.file }]
        );
      }

      const sectionIds = cartSectionIds();
      if (sectionIds.length) fd.append('sections', sectionIds.join(','));

      this._setStatus(t(i18n, 'adding', 'Ekleniyor…'), 'success');
      try {
        const res = await fetch(cartAddUrl(), {
          method: 'POST',
          body: fd,
          headers: { Accept: 'application/json' },
        });
        const data = await res.json().catch(() => ({}));
        if (!res.ok || data.status) {
          throw new Error(data.description || data.message || t(i18n, 'addError', 'Sepete eklenemedi.'));
        }
        this._setStatus(t(i18n, 'added', 'Sepete eklendi.'), 'success');
        const lines = [{ merchandiseId: String(base.id), quantity: 1 }];
        if (this.wantAdapter && adapter?.id) lines.push({ merchandiseId: String(adapter.id), quantity: 1 });
        if (this.wantPrint && print?.id) lines.push({ merchandiseId: String(print.id), quantity: 1 });
        await notifyHorizonCart(data, lines);
        document.dispatchEvent(new CustomEvent('cart:refresh', { detail: data, bubbles: true }));
      } catch (err) {
        console.error('[HexboxCraft]', err);
        this._setStatus(err.message || t(i18n, 'addError', 'Sepete eklenemedi.'), 'error');
      }
    }
  }

  if (!customElements.get('hexbox-craft')) {
    customElements.define('hexbox-craft', HexboxCraft);
  }
})();
